import React, { useState } from "react";
import { PersonStanding } from 'lucide-react';

const AccessibilitySettings = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [fontSize, setFontSize] = useState("16px");
  const [highContrast, setHighContrast] = useState(false);
  const [gifPaused, setGifPaused] = useState(false);

  // Toggle GIF playback
  const toggleGifs = () => {
    setGifPaused(!gifPaused);
    document.querySelectorAll("img").forEach((img) => {
      if (img.src.includes(".gif")) {
        img.style.filter = gifPaused ? "none" : "grayscale(100%)"; // Temporary effect
      }
    });
  };

  return (
    <div className="relative">
      {/* Floating Action Button (FAB) */}
      <button
        className="fixed bottom-8 right-8 bg-black text-white rounded-full p-1.5 shadow-lg z-50 hover:bg-gray-800 transition"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <PersonStanding size={40} />
      </button>

      {/* Accessibility Menu */}
      {menuOpen && (
        <div className="fixed bottom-20 right-8 bg-white p-4 rounded-lg shadow-lg border w-64 space-y-4">
          <h3 className="text-lg font-bold">Accessibility Options</h3>

          {/* Font Size Selector */}
          <label className="block">
            <span className="text-sm font-medium">Font Size:</span>
            <select
              className="mt-1 block w-full p-2 border rounded"
              value={fontSize}
              onChange={(e) => setFontSize(e.target.value)}
            >
              <option value="16px">Default</option>
              <option value="18px">Large</option>
              <option value="20px">Extra Large</option>
            </select>
          </label>

          {/* High Contrast Mode */}
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={highContrast}
              onChange={() => setHighContrast(!highContrast)}
              className="w-4 h-4"
            />
            <span className="text-sm font-medium">High Contrast Mode</span>
          </label>

          {/* Toggle GIFs */}
          <button
            className="w-full px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
            onClick={toggleGifs}
          >
            {gifPaused ? "Play GIFs" : "Stop GIFs"}
          </button>
        </div>
      )}
    </div>
  );
};

export default AccessibilitySettings;
